module.exports = __webpack_public_path__ + "img/64.7.Chla.a80622ad.png";